// ==================================================================================
// Digital Approval System (DAS) - Dashboard Service
// ==================================================================================
// Service functions for dashboard statistics operations
// ==================================================================================

import { axiosClient } from '../../client/axiosClient';
import { ApiResponse } from '../../types/common.types';
import {
  DashboardSummaryDto,
  RequestStatusSummaryDto,
  RequestTypeSummaryDto,
  ApprovalMetricsDto,
  MyWorkSummaryDto,
  RecentActivityDto,
} from '../../types/das/dashboard.types';
import { dashboardEndpoints } from '../../endpoints/das/dashboard.endpoints';

/**
 * Dashboard service
 */
export const dashboardService = {
  /**
   * Get dashboard summary statistics
   */
  getSummary: async (): Promise<DashboardSummaryDto> => {
    const response = await axiosClient.get<ApiResponse<DashboardSummaryDto>>(
      dashboardEndpoints.getSummary()
    );
    return response.data.data;
  },

  /**
   * Get request counts by status
   */
  getStatusSummary: async (): Promise<RequestStatusSummaryDto[]> => {
    const response = await axiosClient.get<ApiResponse<RequestStatusSummaryDto[]>>(
      dashboardEndpoints.getStatusSummary()
    );
    return response.data.data;
  },

  /**
   * Get request counts by type
   */
  getTypeSummary: async (): Promise<RequestTypeSummaryDto[]> => {
    const response = await axiosClient.get<ApiResponse<RequestTypeSummaryDto[]>>(
      dashboardEndpoints.getTypeSummary()
    );
    return response.data.data;
  },

  /**
   * Get approval performance metrics
   */
  getApprovalMetrics: async (): Promise<ApprovalMetricsDto> => {
    const response = await axiosClient.get<ApiResponse<ApprovalMetricsDto>>(
      dashboardEndpoints.getApprovalMetrics()
    );
    return response.data.data;
  },

  /**
   * Get current user's work summary
   */
  getMyWorkSummary: async (): Promise<MyWorkSummaryDto> => {
    const response = await axiosClient.get<ApiResponse<MyWorkSummaryDto>>(
      dashboardEndpoints.getMyWorkSummary()
    );
    return response.data.data;
  },

  /**
   * Get recent activity across the system
   */
  getRecentActivity: async (topN?: number): Promise<RecentActivityDto[]> => {
    const response = await axiosClient.get<ApiResponse<RecentActivityDto[]>>(
      dashboardEndpoints.getRecentActivity(topN)
    );
    return response.data.data;
  },
};
